import { useCallback, useEffect, useLayoutEffect, useState } from 'react';

/**
 * @returns {[(element: any) => void, number]}
 */
export const useContainerWidth = () => {
  const [node, setNode] = useState(null);
  const ref = useCallback((element) => {
    setNode(element);
  }, []);
  const [width, setWidth] = useState(0);

  useLayoutEffect(() => {
    if (!node) return;
    setWidth(node.getBoundingClientRect().width);
  }, [node]);

  useEffect(() => {
    if (!node || typeof ResizeObserver === 'undefined') return undefined;
    const observer = new ResizeObserver((entries) => {
      const rect = entries[0]?.contentRect;
      if (rect) setWidth(rect.width);
    });
    observer.observe(node);
    return () => observer.disconnect();
  }, [node]);

  return [ref, Math.max(0, Math.round(width))];
};
